module.exports = __webpack_public_path__ + "static/media/step4.4507b739.png";